import _ from "lodash";
import React, { useState } from "react";
import LinkModal from "UIComponents/LinkModal";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { LinkOutlined } from "@toddle-edu/ds-icons";
import { useTranslation } from "react-i18next";

const AddLinkReference = ({ parentId, parentType, onUpload }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleUpload = item => {
    const file = _.first(_.get(item, "attachments"));

    if (_.get(file, "type") === "VIDEO") {
      // * Sending this to generate transcript, BE only generate transcript for LINK type
      // * Adding mimeType to as VIDEO to maintain state in FE
      _.set(file, "type", "LINK");
      _.set(file, "mimeType", "VIDEO");
    }
    onUpload(file);
  };

  return (
    <>
      <Tooltip
        dsVersion="2.0"
        tooltip={t("common:add_link")}
        showArrow={true}
        placement="bottom"
      >
        <IconButton
          dsVersion="2.0"
          variant="neutral"
          type="outlined"
          size="small"
          icon={<LinkOutlined />}
          onClick={() => setShowModal(true)}
          testId="worksheet-media-reference-add-link"
        />
      </Tooltip>
      {showModal && (
        <LinkModal
          dsVersion="2.0"
          parentId={parentId}
          onLinkAdd={handleUpload}
          parentType={parentType}
          onClose={() => setShowModal(false)}
          shouldExtractYoutubeDetails={true}
          showDisplayText={false}
        />
      )}
    </>
  );
};

export default AddLinkReference;
